import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { APP_ID, APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import {
  APPLICATION_CONFIGURATION_PATH,
  APPLICATION_CONFIGURATION_URL
} from '@com-delta-idp/angular-core/environment/tokens';
import { NgcModule } from '@com-delta-idp/mnx-components';
import { SmartModule as LoginModalSmartModule } from '@com-delta-idp/mnx-login';
import { OAuthFeatureConfig } from '@com-delta-idp/mnx-oauth';
import {
  provideTrackJsConfigService,
  SkyClubComponent,
  SmartModule as SkyClubModule
} from '@com-delta-idp/mnx-sky-club';
import { installTrackJS, TrackJsConfigService } from '@com-delta-idp/mnx-utils';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';

const oAuthFeatureConfig: OAuthFeatureConfig = {
  app: 'SKYCLUB',
  endpointKey: 'SKY_CLUB_LOGIN_AUTH_CONFIG'
};
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserModule,
    BrowserAnimationsModule,
    LoginModalSmartModule,
    SkyClubModule,
    EffectsModule.forRoot([]),
    !environment.production
      ? StoreDevtoolsModule.instrument({ connectInZone: true })
      : [],
    StoreRouterConnectingModule.forRoot(),
    RouterModule.forRoot(
      [
        {
          path: 'sky-club/purchase-membership',
          component: SkyClubComponent
        }
      ],
      {
        scrollPositionRestoration: 'enabled'
      }
    ),
    NgcModule.forRoot({
      rootUrlName: 'Sky Club'
    })
  ],
  providers: [
    {
      provide: APPLICATION_CONFIGURATION_URL,
      useValue: '/content/www/en_US/config/sky-club.commonconfig.json'
    },
    {
      provide: APPLICATION_CONFIGURATION_PATH,
      useValue: '/content/www/en_US/config/sky-club.commonconfig.json'
    },
    {
      provide: TrackJsConfigService,
      useFactory: provideTrackJsConfigService()
    },
    {
      provide: APP_INITIALIZER,
      useFactory: installTrackJS,
      deps: [TrackJsConfigService],
      multi: true
    },
    {
      provide: 'OAUTH_FEATURE_CONFIG',
      useValue: oAuthFeatureConfig
    },
    {
      provide: 'REDIRECT',
      useValue: false
    },
    {
      provide: 'ACCESSIBLE',
      useValue: true
    },
    RouterModule,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: APP_ID, useValue: 'home' }
  ]
})
export class AppModule {}
